export default {
  translation: {
    // TOP MENU
    topMenu: {
      signin: 'Eintragen',
      about: 'Über Uns',
      support: 'Support',
      newsResources: 'Neuheiten und Forshung',
    },
    // BOTTOM MENU
    bottomMenu: {
      plans: 'Plans',
      product: 'Product',
      contact: 'Contact',
      freeTrial: 'Free trial',
      allPricesInAUD: 'Alle Preise in australischen Dollar',
      allPricesInUS: 'Alle Preise in US-Dollar',
      allPricesInEUR: 'Alle Preise in Euro',
      allPricesInGBP: 'Alle Preise in GBP',
      termsText: 'Durch das Herunterladen der Eyetelligence Software erklären Sie sich einverstanden mit den ',
      privatePolicy: 'Datenschutzbestimmungen',
      and: 'und den',
      termsCondition: 'Allgemeinen Geschäftsbedingungen'
    },
    // SIGN IN
    signin: {
      login: 'Anmelden',
      title: 'Melden Sie sich an, um auf Ihr Eyetelligence Assure-Konto zuzugreifen.',
      freeTrial: 'Kein Konto? Starten Sie Ihr kostenloses Testkonto.',
      inputLabel1: 'Email',
      inputLabel2: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      resetPassword: 'Reset Passwort',
    },
    // SIGN UP
    signup: {
      clinic: {
        firstStep: {
          title: 'Willkommen',
          desc:
            'Damit wir Ihnen ein passendes Angebot machen können, bitten wir Sie, uns folgende Angaben zu machen.',
          inputLabel1: 'Name des Geschäfts oder der Klinik',
          inputLabel2: 'Ihre Funktion',
          inputLabel3: 'Anzahl der Funduskameras',
        },
        thirdStep: {
          title: 'Ihr Auftrag',
          planType: 'Lizenz Wahl',
          freeTrial: 'Kostenlose 30-Tage-Testversion',
          buttonText: 'Starten Sie Ihren kostenlosen Test',
        },
        fourStep: {
          title: 'Fast fertig!',
          desc:
            'Bitte überprüfen Sie Ihren Posteingang. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink geschickt.',
        },
      },
      company: {
        firstStep: {
          title: 'Wir brauchen noch ein paar Details',
          desc:
            'Damit wir Ihnen ein passendes Angebot machen können, bitten wir Sie, uns folgende Angaben zu machen.',
          inputLabel1: 'Name des Geschäfts oder der Klinik',
          inputLabel2: 'Ihre Funktion',
          inputLabel3: 'Land',
          inputLabel4: 'Wie viele Läden?',
          inputLabel5: 'Haben Sie ein zentralisiertes IT-System?',
          inputLabel6: 'Ja',
          inputLabel7: 'Nein',
          buttonText: 'Weiter',
        },
        thirdStep: {
          title: 'Bestätigen Sie Ihre Angaben',
          desc:
            'Bitte überprüfen Sie die folgenden Angaben und bestätigen Sie, dass alles korrekt ist.',
          looksGood: 'Sieht gut aus',
        },
        fourStep: {
          title: 'Danke!',
          desc:
            'Unser Team wird sich in Kürze mit Ihnen in Verbindung setzen, um einen kostenlosen 30-Tage-Test für Sie einzurichten.',
        },
      },
      secondStep: {
        title: 'Wir benötigen noch einige Informationen von Ihnen',
        desc:
          'Wir verwenden diese Informationen, um Ihre kostenlose Testversion einzurichten und Ihr Konto individuell zu gestalten.',
        accountLink: 'Sie haben bereits ein Konto?',
        inputLabel1: 'Ihr vollständiger Name',
        inputLabel2: 'Telefonnummer (optional)',
        inputLabel3: 'E-Mail',
        inputLabel4: 'Passwort erstellen (min 6 max 64)',
        inputLabel5: 'Bestätigung Passwort erstellen',
      },
      infoBlock: {
        yourName: 'Ihr Name',
        yourPosition: 'Ihre Position',
        email: 'E-Mail',
        phone: 'Telefon',
        companyName: 'Name der Firma',
        clinicName: 'Name der Klinik',
        numberOf: 'Anzahl',
        clinics: 'Läden',
        computers: 'Computer',
      },
    },
    // CONFIRM REGISTER
    confirmSuccess: {
      title: 'Erfolg!',
      desc:
        'Ihre E-Mail wurde verifiziert. Fahren Sie auf der nächsten Seite fort, um den Anmeldevorgang abzuschließen und Ihre kostenlose Testversion herunterzuladen.',
    },
    // RESET PASSWORD
    resetPassword: {
      title: 'Passwort ändern',
      mistmatch: 'Falsches Passwort',
      inputLabel1: 'Aktuelles Passwort',
      inputLabel2: 'Neues Kennwort',
      inputLabel3: 'Neues Kennwort wiederholen',
      buttonText: 'Änderungen speichern',
    },

    ////////// FORGOT PASSWORD //////////
    forgotPassword: {
      title: 'Passwort vergessen?',
      forgotPassword: 'Kennwort vergessen?',
      resetPassword: 'Passwort zurücksetzen',
      freeTrial: 'Kein Konto? Starten Sie Ihren kostenlosen Test.',
      inputLabel1: 'E-Mail',
      inputLabel2: 'Kennwort',
    },

    ////////// CREATE NEW PASSWORD //////////
    createNewPassword: {
      title: 'Neues Passwort erstellen',
      inputLabel1: 'Neues Kennwort erstellen',
      inputLabel2: 'Bestätigen Sie das neue Kennwort',
      buttonText: 'Bestätigen Sie',
    },

    ////////// SIGN UP CLINICS //////////
    signupClinics: {
      title: 'Anmeldung für Eyetelligence',
      inputLabel1: 'Vollständiger Name',
      inputLabel2: 'E-Mail',
      inputLabel3: 'Kennwort',
      inputLabel4: 'Handynummer (optional)',
      inputLabel5: 'Name des Unternehmens',
      inputLabel6: 'Standort der Filiale',
      inputLabel7: 'Telefon',
      buttonText: 'Erledigt',
    },

    ////////// GENERAL //////////
    general: {
      backToDashboard: 'ZURÜCK ZUM DASHBOARD',
      backToLicence: 'ZURÜCK ZUR LIZENZ',
      backToLogin: '< Zurück zur Anmeldung',
      step: 'Schritt',
      of: 'von',
      edit: 'ÄNDERN',
      hi: 'Hallo',
      loading: 'Loading',
      continue: 'Weiter',
    },

    // DASHBOARD
    dashboard: {
      yourCurrentPlan: 'Ihr aktueller Plan',
      expired: 'Abgelaufen',
      startedfrom: 'Begonnen von',
      nextBillableDate: 'nächstes fakturierbares Datum',
      youHave: 'Sie haben',
      licences: 'Lizenzen',
      manageLicences: 'Lizenzen verwalten',
      billingHistory: 'Abrechnungshistorie',
      receipt: 'RE',
      youHaveNoBillingHistory: 'Sie haben keine Abrechnungshistorie...',
      accountInformation: 'Kontoinformationen',
      name: 'Name',
      email: 'Em',
      phone: 'Telefon',
      clinicName: 'Name des Geschäfts',
      yourPosition: 'Ihre Position',
      passwordDetails: 'Passwort De',
      creditCardDetails: 'Credit Card Details',
      clickCounter: 'Klickzähler',
      change: 'ÄNDERN',
      contactUs: 'Kontakt',
      pleaseClick: 'Bitte klicken Sie',
      here: 'hier',
      help: 'wenn Sie Hilfe zu Ihrem Konto oder zu Eyetelligence Produkten benötigen',
      activetedCamera: 'Die Kamera wurde erfolgreich aktiviert',
      deactivatedCamera: 'Die Kamera wurde erfolgreich deaktiviert',
      cahgedNickname: 'Kameraname erfolgreich geändert',
    },
    // ENTERPRISE PLAN
    enterprisePlan: {
      freeTrial: 'Ihre 30-tägige kostenlose Testversion von Eyetelligence Assure ist beendet.',
      desc:
        'Ihre Testphase ist jetzt abgelaufen, aber keine Sorge. Sie können weiterhin die leistungsstarken Vorteile von KI für Ihre Patienten nutzen. Einer unserer Mitarbeiter wird sich mit Ihnen in Verbindung setzen, um die nächsten Schritte zu besprechen, oder Sie können sich über die unten stehende E-Mail melden.',
      contactUs: 'Kontakt',
      email: 'E-Mail',
      mail: 'Mail',
      street: 'Diefhoekstraat 8',
      city: '4727 SV Moerstraten',
      chat: 'Lassen Sie uns reden',
      description:
        'Nehmen Sie noch heute Kontakt mit unserem Team auf. Wir sind für Sie da und beantworten gerne Ihre Fragen und Anfragen.',
      loading: 'Laden',
    },
    // LICENCE
    licence: {
      isDelete: 'Sind Sie sicher, dass Sie den aktuellen Plan kündigen wollen?',
      newNname: 'Neuer Name',
      maxCharacters: 'Maximal 32 Zeichen',
      minCharacters: 'Mindestens 1 Zeichen',
      yourLicenceSummary: 'Zusammenfassung Ihrer Lizenz',
      cancelPlan: 'Plan kündigen',
      computerID: 'Computer-ID',
      activationCode: 'Aktivierungscode',
      validDate: 'Gültigkeitsdatum',
      activate: 'Aktivieren',
      revoke: 'Zu',
      number: 'Nummer',
      nickname: 'Spitzname',
      status: 'St',
      active: 'Ac',
      inactive: 'Inaktiv',
      needLicence: 'Brauche eine neue Lizenz',
      upgradePlan: 'Upgrade-Plan',
      cancelPlanPopup: 'Möchten Sie dieses Abonnement wirklich kündigen?'
    },
    // PLAN
    plan: {
      cardDetails: 'Kartendaten',
      pay: 'Bezahlen',
      title: 'Zusammenfassung der Bestellung',
      planType: 'Planart',
      annual: 'Jährlich',
      annually: 'Jährlich (Jährlich zahlen und 10% sparen)',
      monthly: 'Monatlich',
      payPerClick: 'Zahlen pro klick',
      freeTrial: 'Kostenlose 30-Tage-Testversion',
      eachYear:
        'Die Abrechnung erfolgt automatisch jedes Jahr. Sie können Ihren Plan oder Ihre Abrechnungsinformationen über Ihr Konto-Dashboard bearbeiten. Sie können Ihr Abonnement jederzeit kündigen. Die verbleibenden Tage Ihres Abonnements werden Ihnen als Rückerstattung zur Verfügung gestellt.',
      eachMonth:
        'Wird automatisch jeden Monat abgerechnet. Sie können Ihre Tarif- oder Abrechnungsinformationen über das Dashboard Ihres Kontos bearbeiten. Sie können Ihr Abonnement jederzeit kündigen. Die verbleibenden Tage Ihres Abonnements werden Ihnen als Rückerstattung zur Verfügung gestellt.',
      updateCurrentPlan: 'Aktuellen Plan aktualisieren',
      addCard: 'Karte hinzufügen',
      successfullyUpdated: 'Der Plan wurde erfolgreich aktualisiert',
      computerHaveInternet: 'Haben die Computer in Ihrer Praxis Zugang zum Internet?',
      yes: 'Jawohl',
      no: 'nein',
    },
    // UPGRADE PLAN
    upgradePlan: {
      upTo: 'Bis zu ',
      upToSmall: 'bis',
      upToLowerCase: 'bis',
      cameras: 'Kameras',
      specialOffer: 'Sonderangebot',
      month: 'monat',
      monthUppCase: 'Monat',
      monthShort: 'monat',
      mainTitle: 'Eyetelligence Assure Preisgestaltung',
      mainSubTitle: 'Zeit, diese Partnerschaft offiziell zu machen. Wählen Sie unten Ihren Lizenz-Plan und genießen Sie weiterhin alle Vorteile von Eyetelligence Assure. \n' +
          '\n' +
          'Benötigen Sie Hilfe bei der Auswahl eines Lizenz? Kontaktieren Sie einfach unser Team, um den für Sie passenden Plan zu finden.',
      freeTrial: 'Ihre 30-tägige kostenlose Testversion von Eyetelligence Assure ist beendet.',
      timeToMake:
        'Es ist an der Zeit, diese Partnerschaft offiziell zu machen. Wählen Sie unten Ihren Abonnementplan und genießen Sie weiterhin alle Vorteile von Eyetelligence Assure.',
      needHelp:
        'Die Preise gelten pro Kamera, pro Monat, jederzeit kündbar. Kostenloser einmonatiger Test für alle Pläne. Jeder Plan beinhaltet eine kostenlose 30-Tage-Testversion. Keine Kreditkarte erforderlich. Testen Sie es jetzt.',
      chooseThePlan: 'Wählen Sie den für Sie passenden Tarif',
      single: 'Single',
      cameraLicence: 'Kamera-Lizenz',
      annuallySave: 'Jährlich abgerechnet, sparen Sie',
      multipleSave: 'Pro Kamera, jährlich abgerechnet, sparen Sie',
      orPay: 'Oder zahlen Sie',
      billedMonthly: 'pro Kamera, monatlich abgerechnet',
      billedMonthlyMultiple: 'pro Kamera, monatlich abgerechnet',
      multiple: 'Mehrere',
      cameraLicences: 'Kamera-Lizenzen',
      perCamera: 'Pro Kamera, monatlich abgerechne',
      perCameraShort: 'Pro Kamera, monatlich abgerechne',
      perAnalysis: 'pro Analyse',
      enterprise: 'Unternehmen',
      youHaveSix:
        'Wenn Sie sechs oder mehr Kameras haben, helfen wir Ihnen gerne dabei, einen Plan und alle Anforderungen auf Sie zuzuschneiden, um sicherzustellen, dass Sie die richtige Lösung für Ihr Team erhalten.',
      select: 'Plan Auswählen',
      FAQ: 'FAQ',
      FAQ1Title: 'Muss ich mich für einen Ganzjahresplan entscheiden?',
      FAQ1Desc:
        'Nein, wir bieten sowohl monatliche als auch jährliche Tarife an. Jahrespläne werden im Voraus abgerechnet (der monatliche Preis wird zum Vergleich angezeigt). Wenn Sie sich für ein Jahresabonnement entscheiden, erhalten Sie 20 % Rabatt auf Ihr Abonnement.',
      FAQ2Title: 'Kann ich meinen Plan ändern?',
      FAQ2Desc:
        'Ja, Sie können Ihren Tarif jederzeit über Ihr Konto-Dashboard upgraden, downgraden oder kündigen.',
      FAQ3Title: 'Was ist die Kündigungspolitik?',
      FAQ3Desc:
        'Sie können Ihren Lizenz jederzeit über Ihr Konto-Dashboard kündigen. Nach der Kündigung wird Ihnen der nächste Abrechnungszeitraum nicht in Rechnung gestellt. Sie können Eyetelligence Assure für den Rest Ihres Abrechnungszeitraums nutzen. Für die verbleibende Zeit werden keine Rückerstattungen gewährt.',
      chat: 'Chatten',
      getInTouch:
        'Nehmen Sie noch heute Kontakt mit unserem Team auf. Wir sind hier, um Ihre Fragen und Anfragen zu beantworten.',
      getInTouchButton: 'Nehmen Sie Kontakt auf',
    },
    // PROFILE
    profile: {
      title: 'Konto-Informationen',
      clinicName: 'Name der Laden',
      yourPosition: 'Ihre Position',
      yourFullName: 'Ihr vollständiger Name',
      phoneNumber: 'Telefonnummer',
      email: 'E-Mail',
      saveChanges: 'Änderungen speichern',
    },
    creditCard: {
      title: 'Details zu den Kreditkarten',
      delete: 'Löschen',
    },
    updateUserData: {
      updateUserInfo: 'Ihre Daten wurden erfolgreich aktualisiert',
      passwordUpdate: 'Das Passwort wurde erfolgreich aktualisiert',
      cardAdded: 'Ihre Karte wurde erfolgreich hinzugefügt',
      cardDelete: 'Ihre Karte wurde erfolgreich gelöscht',
    },

    ////////// AUTH //////////
    auth: {
      linkSent: 'Link an E-Mail gesendet',
      passwordReset: 'Ihr Passwort wurde erfolgreich zurückgesetzt',
    },
  },
};
